(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ald-hero"] && !Shopify.designMode) return;
  try {
    
  function initAldHero(root) {
    if (!root || root.dataset.aldInit === "true") return;
    root.dataset.aldInit = "true";

    // Full-bleed: gebruik de echte zichtbare breedte (zonder scrollbalk)
    root.style.setProperty("--ald-vw", document.documentElement.clientWidth + "px");

    var video = root.querySelector(".ald-hero__media video");
    var muteBtn = root.querySelector("[data-ald-mute]");
    var clock = root.querySelector("[data-ald-clock]");

    // Mute-knop
    if (video && muteBtn) {
      muteBtn.addEventListener("click", function () {
        video.muted = !video.muted;
        muteBtn.setAttribute("aria-pressed", String(video.muted));
        muteBtn.setAttribute("aria-label", video.muted ? "Geluid aanzetten" : "Geluid uitzetten");
        if (!video.muted) { video.play().catch(function () {}); }
      });
    }

    // Live datum/tijd (Nederlands)
    if (clock) {
      var tz = clock.dataset.timezone || "Europe/Amsterdam";
      var tzLabel = clock.dataset.tzLabel || "";
      var location = clock.dataset.location || "";

      var render = function () {
        var now = new Date();
        var date = new Intl.DateTimeFormat("nl-NL", {
          timeZone: tz, weekday: "long", year: "numeric", month: "long", day: "numeric"
        }).format(now);
        var time = new Intl.DateTimeFormat("nl-NL", {
          timeZone: tz, hour: "2-digit", minute: "2-digit", hour12: false
        }).format(now);
        clock.textContent = location + " | " + date + " | " + time + (tzLabel ? " " + tzLabel : "");
      };
      render();
      clearInterval(clock._aldTimer);
      clock._aldTimer = setInterval(render, 1000);
    }
  }

  function initAll() {
    document.querySelectorAll(".ald-hero").forEach(initAldHero);
  }

  // Werk de full-bleed breedte bij bij resize / draaien van het scherm
  if (!window.__aldVwBound) {
    window.__aldVwBound = true;
    window.addEventListener("resize", function () {
      var w = document.documentElement.clientWidth + "px";
      document.querySelectorAll(".ald-hero").forEach(function (el) {
        el.style.setProperty("--ald-vw", w);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", initAll);
  initAll();

  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".ald-hero") || (e.target.classList && e.target.classList.contains("ald-hero") ? e.target : null);
    if (el) { el.dataset.aldInit = "false"; initAldHero(el); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barista-keuze"] && !Shopify.designMode) return;
  try {
    
  function initKvhBarista(root) {
    if (!root || root.dataset.kvhInit === "true") return;
    root.dataset.kvhInit = "true";

    var video = root.querySelector(".kvh-barista__video-wrap video");
    var muteBtn = root.querySelector("[data-kvh-mute]");
    var wrap = root.querySelector(".kvh-barista__video-wrap");
    var playBtn = root.querySelector("[data-kvh-play]");

    if (video) {
      var syncState = function () {
        if (wrap) { wrap.classList.toggle("is-paused", video.paused); }
      };
      video.addEventListener("play", syncState);
      video.addEventListener("pause", syncState);

      // Probeer autoplay; lukt het niet (bv. energiebesparing), dan blijft de poster + play-knop staan
      var attempt = video.play();
      if (attempt && typeof attempt.then === "function") {
        attempt.then(syncState).catch(syncState);
      } else {
        syncState();
      }

      if (playBtn) {
        playBtn.addEventListener("click", function () {
          video.play().catch(function () {});
        });
      }
    }

    if (video && muteBtn) {
      muteBtn.addEventListener("click", function () {
        video.muted = !video.muted;
        muteBtn.setAttribute("aria-pressed", String(video.muted));
        muteBtn.setAttribute("aria-label", video.muted ? "Geluid aanzetten" : "Geluid uitzetten");
        if (!video.muted) { video.play().catch(function () {}); }
      });
    }
  }

  function initAllKvh() {
    document.querySelectorAll(".kvh-barista").forEach(initKvhBarista);
  }

  document.addEventListener("DOMContentLoaded", initAllKvh);
  initAllKvh();

  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".kvh-barista") || (e.target.classList && e.target.classList.contains("kvh-barista") ? e.target : null);
    if (el) { el.dataset.kvhInit = "false"; initKvhBarista(el); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koffiekar-aanvraag"] && !Shopify.designMode) return;
  try {
    
  /* Datum: geen aanvragen in het verleden */
  document.querySelectorAll('.kvh-lform input[type="date"]').forEach(function (el) {
    var d = new Date();
    var iso = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    el.min = iso;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kvh-fotomuur"] && !Shopify.designMode) return;
  try {
    
  function initKvhMuur(root) {
    if (!root || root.dataset.kvhMuurInit === "true") return;
    root.dataset.kvhMuurInit = "true";

    var lightbox = root.querySelector("[data-kvh-lightbox]");
    if (!lightbox) return;
    var img = lightbox.querySelector("[data-kvh-lightbox-img]");
    var caption = lightbox.querySelector("[data-kvh-lightbox-caption]");
    var sluitBtn = lightbox.querySelector("[data-kvh-sluit]");
    var laatsteFocus = null;

    function open(src, alt) {
      img.src = src;
      img.alt = alt || "";
      caption.textContent = alt || "";
      lightbox.hidden = false;
      document.documentElement.style.overflow = "hidden";
      sluitBtn.focus();
    }

    function sluit() {
      lightbox.hidden = true;
      img.src = "";
      document.documentElement.style.overflow = "";
      if (laatsteFocus) { laatsteFocus.focus(); }
    }

    root.querySelectorAll("[data-kvh-foto]").forEach(function (knop) {
      knop.addEventListener("click", function () {
        laatsteFocus = knop;
        open(knop.getAttribute("data-kvh-foto"), knop.getAttribute("data-kvh-alt"));
      });
    });

    sluitBtn.addEventListener("click", sluit);
    lightbox.addEventListener("click", function (e) {
      if (e.target === lightbox) { sluit(); }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !lightbox.hidden) { sluit(); }
    });
  }

  function initAlleKvhMuren() {
    document.querySelectorAll(".kvh-muur").forEach(initKvhMuur);
  }

  document.addEventListener("DOMContentLoaded", initAlleKvhMuren);
  initAlleKvhMuren();

  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".kvh-muur") || (e.target.classList && e.target.classList.contains("kvh-muur") ? e.target : null);
    if (el) { el.dataset.kvhMuurInit = "false"; initKvhMuur(el); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kvh-hero-v2"] && !Shopify.designMode) return;
  try {
    
  function initKvhHero2(root) {
    if (!root || root.dataset.khInit === "true") return;
    root.dataset.khInit = "true";
    root.style.setProperty("--kh-vw", document.documentElement.clientWidth + "px");

    var clock = root.querySelector("[data-kh-clock]");
    if (clock) {
      var tz = clock.dataset.tz || "Europe/Amsterdam";
      var render = function () {
        var now = new Date();
        var date = new Intl.DateTimeFormat("nl-NL", { timeZone: tz, weekday: "long", day: "numeric", month: "long", year: "numeric" }).format(now);
        var time = new Intl.DateTimeFormat("nl-NL", { timeZone: tz, hour: "2-digit", minute: "2-digit", hour12: false }).format(now);
        var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
        clock.innerHTML = esc(clock.dataset.loc) + '<span class="kvh-h2__date"> | ' + esc(date) + '</span> | ' + esc(time)
          + (clock.dataset.after ? '<span class="kvh-h2__after"> ' + esc(clock.dataset.after) + '</span>' : "");
      };
      render();
      clearInterval(clock._khTimer);
      clock._khTimer = setInterval(render, 1000);
    }
  }
  function initKvhHero2All() { document.querySelectorAll(".kvh-h2").forEach(initKvhHero2); }
  if (!window.__khVwBound) {
    window.__khVwBound = true;
    window.addEventListener("resize", function () {
      var w = document.documentElement.clientWidth + "px";
      document.querySelectorAll(".kvh-h2").forEach(function (el) { el.style.setProperty("--kh-vw", w); });
    });
  }
  document.addEventListener("DOMContentLoaded", initKvhHero2All);
  initKvhHero2All();
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".kvh-h2");
    if (el) { el.dataset.khInit = "false"; initKvhHero2(el); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["over-deze-koffie"] && !Shopify.designMode) return;
  try {
    
  function initKvhPinfo(root) {
    if (!root || root.dataset.kvhPinfoInit === "true") return;
    root.dataset.kvhPinfoInit = "true";

    var wrap = root.querySelector(".kvh-pinfo__video-wrap");
    if (!wrap) return;
    var video = wrap.querySelector("video");
    var muteBtn = wrap.querySelector("[data-kvh-pmute]");
    var playBtn = wrap.querySelector("[data-kvh-pplay]");
    if (!video) return;

    var syncState = function () {
      wrap.classList.toggle("is-paused", video.paused);
    };
    video.addEventListener("play", syncState);
    video.addEventListener("pause", syncState);

    var attempt = video.play();
    if (attempt && typeof attempt.then === "function") {
      attempt.then(syncState).catch(syncState);
    } else {
      syncState();
    }

    if (playBtn) {
      playBtn.addEventListener("click", function () {
        video.muted = false;
        if (muteBtn) {
          muteBtn.setAttribute("aria-pressed", "false");
          muteBtn.setAttribute("aria-label", "Geluid uitzetten");
        }
        video.play().catch(function () {});
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener("click", function () {
        video.muted = !video.muted;
        muteBtn.setAttribute("aria-pressed", String(video.muted));
        muteBtn.setAttribute("aria-label", video.muted ? "Geluid aanzetten" : "Geluid uitzetten");
        if (!video.muted) { video.play().catch(function () {}); }
      });
    }
  }

  function initAlleKvhPinfo() {
    document.querySelectorAll(".kvh-pinfo").forEach(initKvhPinfo);
  }

  document.addEventListener("DOMContentLoaded", initAlleKvhPinfo);
  initAlleKvhPinfo();

  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".kvh-pinfo") || (e.target.classList && e.target.classList.contains("kvh-pinfo") ? e.target : null);
    if (el) { el.dataset.kvhPinfoInit = "false"; initKvhPinfo(el); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  function initAldHero(root) {
    if (!root || root.dataset.aldInit === "true") return;
    root.dataset.aldInit = "true";

    // Full-bleed: gebruik de echte zichtbare breedte (zonder scrollbalk)
    root.style.setProperty("--ald-vw", document.documentElement.clientWidth + "px");

    var video = root.querySelector(".ald-hero__media video");
    var muteBtn = root.querySelector("[data-ald-mute]");
    var clock = root.querySelector("[data-ald-clock]");

    // Mute-knop
    if (video && muteBtn) {
      muteBtn.addEventListener("click", function () {
        video.muted = !video.muted;
        muteBtn.setAttribute("aria-pressed", String(video.muted));
        muteBtn.setAttribute("aria-label", video.muted ? "Geluid aanzetten" : "Geluid uitzetten");
        if (!video.muted) { video.play().catch(function () {}); }
      });
    }

    // Live datum/tijd (Nederlands)
    if (clock) {
      var tz = clock.dataset.timezone || "Europe/Amsterdam";
      var tzLabel = clock.dataset.tzLabel || "";
      var location = clock.dataset.location || "";

      var render = function () {
        var now = new Date();
        var date = new Intl.DateTimeFormat("nl-NL", {
          timeZone: tz, weekday: "long", year: "numeric", month: "long", day: "numeric"
        }).format(now);
        var time = new Intl.DateTimeFormat("nl-NL", {
          timeZone: tz, hour: "2-digit", minute: "2-digit", hour12: false
        }).format(now);
        clock.textContent = location + " | " + date + " | " + time + (tzLabel ? " " + tzLabel : "");
      };
      render();
      clearInterval(clock._aldTimer);
      clock._aldTimer = setInterval(render, 1000);
    }
  }

  function initAll() {
    document.querySelectorAll(".ald-hero").forEach(initAldHero);
  }

  // Werk de full-bleed breedte bij bij resize / draaien van het scherm
  if (!window.__aldVwBound) {
    window.__aldVwBound = true;
    window.addEventListener("resize", function () {
      var w = document.documentElement.clientWidth + "px";
      document.querySelectorAll(".ald-hero").forEach(function (el) {
        el.style.setProperty("--ald-vw", w);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", initAll);
  initAll();

  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".ald-hero") || (e.target.classList && e.target.classList.contains("ald-hero") ? e.target : null);
    if (el) { el.dataset.aldInit = "false"; initAldHero(el); }
  });

  } catch(e) { console.error(e); }
})();
})();
